module.exports = __webpack_public_path__ + "static/img/new-06.fadf068.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-06.png
// module id = Dlqm
// module chunks = 0